// extracted by mini-css-extract-plugin
export var arrows = "_84-6";
export var decrementer = "_84-a";
export var disabled = "_84-4";
export var error = "_84-1";
export var hiddenText = "_84-b";
export var incrementer = "_84-9";
export var input = "_84-8";
export var inputWrapper = "_84-0";
export var leadingIcon = "_84-c";
export var readonly = "_84-3";
export var regular = "_84-7";
export var small = "_84-5";
export var warning = "_84-2";